module.exports = "<div class=\"postit-container\">\n\t<div class=\"postit color-{{postit.color}}\">\n\t\t<span class=\"text-center\">\n\t\t\t{{postit.content}}\n\t\t</span>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/app/postit/postit.component.html
// module id = ../../../../../src/app/postit/postit.component.html
// module chunks = main